<template>
    <div class="dashboard" >
        <v-container class="mt-10">
             <v-layout id="scroll" column>
            <v-card flat  class="px-3" v-for="test in tests" :key="test.name">
            <v-layout @click="submitting(test.name,test.subject,test.dueBy,test.link,test.id)" row wrap class="px-4 py-2 " :class="test.status">
            <v-flex xs4 sm4 md4>
                <div class="caption grey--text">Work Title</div>
                <div>{{test.name}}</div>
            </v-flex>
            <v-flex xs4 sm4 md4>
                <div class="caption grey--text">Subject</div>
                <div>{{test.subject}}</div>
            </v-flex>
            <v-flex xs2 sm2 md2>
                <div class="caption grey--text">Due by</div>
                <div>{{test.dueBy}}</div>
            </v-flex>
            <v-flex xs2 sm2 md2>
                <div right>
                <v-chip small  :id="test.status" class="caption white--text mt-3" >{{test.status}}</v-chip>
                </div>
            </v-flex>
            </v-layout>
            <v-divider></v-divider>
      </v-card>
      </v-layout> 
      <v-layout v-show="gonna" class="mt-10" column xs4 lg4 xl4 md4 sm4>
          <v-text-field solo :value="name"></v-text-field>
          <v-text-field solo  :value="due"></v-text-field>
          <v-text-field solo :value="subject"></v-text-field>
          <v-text-field solo :value="name"></v-text-field>
          <v-file-input @change="previewImage" solo accept="file/*"></v-file-input>
          <div id="buttons">
          <v-btn link :href="link" target="_blank">Question paper</v-btn>
          <v-btn class="ml-4" type="submit" @click.prevent="onUpload">Submit</v-btn>
          </div>
      </v-layout>
    </v-container>
    </div>  
</template>


<script>
import db from '../components/firebaseinit'
import {auth} from '../components/firebaseinit'
import firebase from 'firebase'
export default {
    props:{
    expandonHover:{
      type:Boolean
    }
  },
 data(){
     return{
         works:[
             {name:"cycle test",sub:"cloud clomputing",stat:"Completed",due:"12/09/20"},
             {name:"cycle test",sub:"Hospital Management",stat:"Overdue",due:"16/09/20"},
             {name:"cycle test",sub:"Human Computer Interaction",stat:"Ongoing",due:"14/09/20"}
         ],
         tests:[],
         currentUser:null,
         name:null,
         due:null,
         subject:null,
         uploadValue:null,
         imageData:null,
         picture:null,
         qlink:null,
         link:null,
         gonna:false,
         userName:"Pon Sankar",
         id:null,
         arr:[],
         i:false
     }
 },
 beforeMount(){
   console.log(auth.currentUser.email)
      let a=new Date();
			let c= a.getMonth()+1;
			let b=a.getDate();
			let d=a.getFullYear();
			if(c<10){
				c='0'+c.toString();
			}
			if(b<10){
				b='0'+b.toString();
			}
			d=d.toString();
			let e=[d,c,b].join('/')
          this.currentUser=auth.currentUser.email
          console.log(auth.currentUser)
          db.collection('students').where('Mail','==',auth.currentUser.email).get().then(query => {
            query.forEach(val => {
              console.log(val.data().Mail)
              if(val.data().Mail==auth.currentUser.email){
                // this.i=true
                this.currentUser=val.data().Name
                console.log(this.currentUser)
              }
            })
          })
          console.log(this.i)
          // if(this.i){
          db.collection('tests').get().then(doc => {
                console.log(doc.size)
                doc.forEach(r => {
                  let name=r.data().Name
                  let sub= r.data().Sub
                  let due= r.data().Due
                  let links=r.data().qlink
                  let id=r.id
                  r.data().status.forEach(a => {
                    if(a.name==this.currentUser){
                    if(a.stat==true){
                      let sta='Completed'
                      console.log({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
                      this.tests.push({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
                    }
                    else{
                        if(due>e){
                          let sta='Ongoing'
                          console.log({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
                          this.tests.push({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
                        }
                        else{
                          let sta='Overdue'
                          console.log({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
                          this.tests.push({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
                        }
                    }}
                  })
                })
                })
                console.log("hello")
          // }
          // else{
          //   this.$router.push('/t')
          // }
          

 },
 methods:{
   submitting:function(name,subject,due,link,id){
     this.name=name
     this.due=due
     this.link=link
     this.subject=subject
     this.gonna=true
     this.id=id
      db.collection('tests').doc(this.id).get().then(hi =>{
                  console.log(hi.data().status)
                  this.arr=hi.data().status
                  this.arr.forEach(a => {
                    if(a.name==this.userName){
                      a.stat=true
                    }
                  })
              })
   },
   previewImage:function(event){
            this.uploadValue=0
            this.picture=null
            console.log(event.name)
            this.imageData= event
            console.log(this.imageData)
        },
        onUpload:function(){
             
            this.picture=null
            const storageRef=firebase.storage().ref(`${this.imageData.name}`).put(this.imageData)
            storageRef.on('state_changed',snapshot => {
                this.uploadValue=(snapshot.bytesTransferred/snapshot.totalBytes)*100
            },err => {console.log(err.message)},
            ()=>{
                // this.uploadValue=100
                storageRef.snapshot.ref.getDownloadURL().then((url)=> {
                    this.picture=url
                    // console.log(url)
                    // console.log(this.id)
                    this.arr.forEach(a => {
                      if(a.name==this.userName){
                        a.link=url
                      }
                    })
                    db.collection('tests').doc(this.id).update({
                      status:this.arr,
                      link:url
                    })
                    .then(a => {
                      console.log(a)
                    })
                    //  db.collection('tests').where('id','==',this.id).get().then(doc => {
                    //   doc.status.forEach(a => {
                    //     if(a.name==this.userName){
                    //       doc.ref.update({status:true})
                    //     }
                    //   })
                    //   console.log(doc)
                    //   console.log("hi")
                        
                    //  })    
                })  
            }
            )  
            //  db.collection('test').add({
            //     type: this.assigning,
            //     Sub: this.subject,
            //     Name:this.name,
            //     Due:this.date,
            //     status:this.students,
            //     qlink:this.picture
            // }).then(docref => {
            //     console.log(this.students)
            //     console.log(docref)
            //     // this.$router.push('/')
            // }).catch(err => console.log(err))
        }
 }
//  ,
//  updated(){
//     let a=new Date();
// 			let c= a.getMonth()+1;
// 			let b=a.getDate();
// 			let d=a.getFullYear();
// 			if(c<10){
// 				c='0'+c.toString();
// 			}
// 			if(b<10){
// 				b='0'+b.toString();
// 			}
// 			d=d.toString();
// 			let e=[d,c,b].join('/')
//           this.currentUser=auth.currentUser.email
//     db.collection('tests').get().then(doc => {
//                 console.log(doc.size)
//                 doc.forEach(r => {
//                   let name=r.data().Name
//                   let sub= r.data().Sub
//                   let due= r.data().Due
//                   let links=r.data().qlink
//                   let id=r.id
//                   r.data().status.forEach(a => {
//                     if(a.name=="Pon Sankar"){
//                     if(a.stat==true){
//                       let sta='Completed'
//                       console.log({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
//                       this.tests.push({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
//                     }
//                     else{
//                         if(due>e){
//                           let sta='Ongoing'
//                           console.log({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
//                           this.tests.push({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
//                         }
//                         else{
//                           let sta='Overdue'
//                           console.log({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
//                           this.tests.push({name:name,subject:sub,dueBy:due,status:sta,link:links,id:id})
//                         }
//                     }}
//                   })
//                 })
//                 })
          

//  }
}
</script>

<style scoped>
.v-btn{
  width: 200px !important;
}

.v-text-field{
  width: 400px !important;
}
.Completed{
  border-left:4px solid #3cd1c2;
}
.Ongoing{
  border-left:4px solid orange;
}
.Overdue{
  border-left:4px solid tomato ;
}
#Completed{
  background:  #3cd1c2;
}
#Ongoing{
  background:  orange;
}
#Overdue{
  background:  tomato ;
  content:"hi";
}
#scroll{
  overflow: auto;
}
#buttons{
  display: inline-flex;
}
</style>